import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { startsWith } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';

// Import Selectors
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { requestPretentOrganization } from '../../../Auth/AuthActions';

export default (ComposedComponent) => {
  class HomeOrg extends Component {
    constructor() {
      super();
      this.state = {
        loading: true,
        done: false,
        errors: null,
      };
    }

    componentWillMount() {
      const {
        organization,
        location: { pathname },
        match: { params: { organizationId, resourceId, type } },
      } = this.props;

      const currentOrganizationId = organization.organization_id;
      let requestedOrganizationId = organizationId;
      if (type === 'azure' && !startsWith(requestedOrganizationId, 'md-')) {
        requestedOrganizationId = `md-${requestedOrganizationId}`;
      } else if (type === 'hubspot' && !startsWith(requestedOrganizationId, 'hs-')) {
        requestedOrganizationId = `hs-${requestedOrganizationId}`;
      }
      if (!type) {
        // backward compatible
        // salesforce by default
        const isExcluded = (pathname || '').indexOf('/exclude-opportunities/') > 0;
        const url = `/request-feedback/force/organizations/${requestedOrganizationId}/${(isExcluded ? 'exclude-opportunities' : 'opportunities')}/${resourceId}`;
        window.location.href = url;
        return;
      }
      
      if (currentOrganizationId !== requestedOrganizationId) {
        this.setState({ loading: true, done: false, errors: null }, () => {
          this.props.dispatch(requestPretentOrganization(requestedOrganizationId))
            .then(
              () => {
                this.setState({ loading: false, done: true });
              },
              (errors) => {
                const msg = errors && errors.data ? errors.data.message || 'Permission denied' : 'Permission denied';
                this.setState({ loading: false, done: false, errors: msg });
              },
            );
        });
      } else {
        this.setState({ loading: false, done: true });
      }
    }
  
    render() {
      const { loading, done, errors } = this.state;
      if (loading) {
        return (
          <div className="container">
            <p />
            {loading && <ProgressBar />}
          </div>
        );
      }
      if (!loading && done) {
        return (<ComposedComponent {...this.props} />);
      }
      if (!loading && errors !== null) {
        return (
          <div className="container">
            <p />
            <div className="alert alert-danger">
              {errors}
            </div>
          </div>
        );
      }
      return null;
    }
  }

  function mapStateToProps(state, ownProps) {
    const { location: { pathname } } = ownProps;
    const isStandalone = startsWith(pathname, '/apex');
    return {
      isStandalone,
      organization: getUserCurrentOrganization(state),
    };
  }

  HomeOrg.propTypes = {
    dispatch: PropTypes.func.isRequired,
    isStandalone: PropTypes.bool,
    organization: PropTypes.shape({
      organization_id: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        organizationId: PropTypes.string,
        resourceId: PropTypes.string,
        type: PropTypes.string,
      }),
    }).isRequired,
  };
  HomeOrg.defaultProps = {
    isStandalone: false,
  };

  HomeOrg.contextTypes = {
    router: PropTypes.shape({}),
  };


  return connect(mapStateToProps)(HomeOrg);
}
